<template>
    <div>

    </div>
</template>

<script>
    import {EventBus} from '../../event-bus.js';
    import Noty from 'noty';
   

    export default {
        name: 'noty',
        data () {
            return {
                last: null,
            }
        },
        mounted(){
            EventBus.$on('noty', function(data){

                new Noty({
                    text: data.msg,
                    type: data.type,
                    theme: 'metroui',
                    timeout: 2000
                }).show();

            });


        },
        updated(){
        
        },
        methods:{
           
        },  
        components:{
            
        }
        
    }
</script>



// WEBPACK FOOTER //
// src/js/components/helpers/Noty.vue